import Vue from 'vue'
import Router from 'vue-router'

import Daylight from './views/Daylight.vue'
import Failure from './views/Failure.vue'


const DaylightClientRouter = new Router({
  routes: [
    {
      path: '/',
      name: 'daylight',
      component: Daylight
    },
    {
      path: '/failure',
      name: 'failure',
      component: Failure
    }
  ]
})

export default DaylightClientRouter

Vue.use(Router)
